import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import { Heading, ListingCard, NamedLink } from '../../components';

import css from './ListingPage.module.css';

/**
 * SectionMoreFromShop displays up to 4 other listings from the same seller.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.listing>} props.relatedListings - Other listings from the same seller
 * @param {propTypes.listing} props.currentListing - The current listing being viewed
 * @param {string} props.authorId - The seller's user ID
 * @returns {JSX.Element}
 */
const SectionMoreFromShop = props => {
  const { relatedListings = [], currentListing, authorId } = props;

  if (!authorId || relatedListings.length === 0) {
    return null;
  }

  // Filter out current listing and show up to 4
  const displayListings = relatedListings
    .filter(listing => listing?.id?.uuid && listing.id.uuid !== currentListing?.id?.uuid)
    .slice(0, 4);

  if (displayListings.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionMoreFromShop}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="SectionMoreFromShop.heading" />
      </Heading>
      <div className={css.relatedListingsGrid}>
        {displayListings.map(listing => (
          <ListingCard key={listing.id.uuid} listing={listing} />
        ))}
      </div>
      <div className={css.viewAllButtonWrapper}>
        <NamedLink
          className={css.viewAllLink}
          name="ShopPage"
          params={{ id: authorId }}
        >
          <FormattedMessage id="SectionMoreFromShop.viewAllLink" />
        </NamedLink>
      </div>
    </section>
  );
};

SectionMoreFromShop.propTypes = {
  relatedListings: PropTypes.arrayOf(propTypes.listing),
  currentListing: propTypes.listing.isRequired,
  authorId: PropTypes.string,
};

export default SectionMoreFromShop;
